'use client';

import NextError from 'next/error';
import { reportSentryError } from '@/services/sentry';
import { useEffect } from 'react';
import { getErrorRenderMode } from '@/components/ErrorPage/errorPage';
import { env } from '@/utils/env';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    reportSentryError(error, {
      domain: 'runtime',
      stage: 'global_error_boundary',
      tags: {
        'error.source': 'frontend_runtime',
        'error.status_code': 500,
        monitoring_priority: 'frontend_500',
        'render.mode': getErrorRenderMode(error),
      },
      // SSR 报错在客户端边界被 Next.js 脱敏，digest 可作为错误签名关联服务端日志。
      extra: {
        digest: error.digest,
      },
    });
  }, [error]);

  /**
   * 这里的 lang 写死环境变量里设置的值
   */
  return (
    <html lang={env.NEXT_PUBLIC_SITE_LANG}>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
